import StorageManager from './StorageManager'
import { v4 as uuid } from 'uuid'
import { COUNTRIES, getDefaultCountryId } from '../config/countries-data'
import { mixtilesAxios } from '../utils/ApiUtils'
import { normalizeAddress } from '../stores/addressStore/address.utils'

const KEY_ORDER_LOCAL_ID = 'orderLocalId'

export function getOrderLocalId() {
  let localId = StorageManager.get(KEY_ORDER_LOCAL_ID)
  if (!localId) {
    localId = uuid()
    StorageManager.set(KEY_ORDER_LOCAL_ID, localId)
  }
  return localId
}

export function resetOrderLocalId() {
  StorageManager.set(KEY_ORDER_LOCAL_ID, null)
}

export async function fetchDeliveryPromise({
  address,
  isTopQueueOn,
  uploads,
  variantsIds,
  productType,
  customerEmail,
  pricingCountry,
  timeout,
}) {
  const params = {
    userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    tileType: uploads[0]?.tileType,
    pricingCountry,
    destinationCountry:
      COUNTRIES[
        address && address.countryId ? address.countryId : getDefaultCountryId()
      ].code,
    address: address ? normalizeAddress(address) : {},
    topQueue: isTopQueueOn,
    uploads,
    customerEmail,
    variantsIds,
    productType,
    isPickupEnabled: false,
  }

  // No retries here: the caller's query retries, so its attempts bound the wait.
  return mixtilesAxios
    .post('v4/shippingOptions', params, { timeout }, 0)
    .then((response) => response.data)
}
